module.exports = __webpack_public_path__ + "img/PSMIS_LOGO.92f99c5e.png";